import { useEffect } from "react";
import { tr } from '@/i18n/tr';
import { toast } from "sonner";

// Polls /version.json — when a new version ships, auto-reloads (waits if a sale is in progress)
export const UpdateChecker = () => {
  useEffect(() => {
    let timer = null;
    let notified = false;

    const check = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
        if (!res.ok) return;
        const { version } = await res.json();
        const current = localStorage.getItem("sellox_force_ver");
        if (!version || !current || version === current) return;
        const cartBusy = (window.__selloxCartCount || 0) > 0;
        if (cartBusy) {
          if (!notified) {
            notified = true;
            toast.info(tr('x_871b1e0c'));
          }
          timer = setTimeout(check, 60 * 1000);
          return;
        }
        toast.success(tr('x_77dbaf27'));
        setTimeout(() => window.location.reload(true), 2000);
      } catch {}
    };

    const interval = setInterval(check, 5 * 60 * 1000);
    const onVisible = () => { if (document.visibilityState === "visible") check(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      clearInterval(interval);
      if (timer) clearTimeout(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);
  return null;
};
